import React from 'react';
import Type from 'prop-types';
import { observer } from 'mobx-react-lite';
import { Field } from 'formik';
import * as Yup from 'yup';
import { Typography, Button } from '@material-ui/core';
import { TextField } from 'formik-material-ui';
import { authStore } from 'stores';
import { useCountDownTimer } from 'hooks';
import { ru } from 'locale';
import useStyles from './GetToken.styles';

const GetToken = observer(props => {
  const classes = useStyles();
  const { values } = props;
  const { resendCode } = authStore;
  const { countdown, start, canStart } = useCountDownTimer({ timer: 30 });

  const handleResendCode = () => {
    if (!canStart) {
      start();
      resendCode(values);
    }
  };

  return (
    <>
      <Typography variant="body1" className={classes.text}>
        {ru.enterCodeFromSms}
        <b>{values.phone}</b>
      </Typography>
      <Field
        name="code"
        label={ru.confirmationCode}
        component={TextField}
        inputProps={{
          maxLength: 4,
          autoComplete: 'one-time-code',
          inputMode: 'numeric',
          pattern: '[0-9]*',
        }}
        autoFocus
        required
        fullWidth
      />
      <Button color="primary" className={classes.resendButton} onClick={handleResendCode}>
        {canStart ? `${ru.resendCodeAfter} ${countdown} сек.` : ru.resendCode}
      </Button>
    </>
  );
});

GetToken.propTypes = {
  values: Type.shape({
    phone: Type.string.isRequired,
    code: Type.string,
  }).isRequired,
};

GetToken.initialValues = {
  code: '',
};

GetToken.submitHandler = formData => {
  return authStore.signIn(formData);
};

GetToken.validationSchema = Yup.object().shape({
  code: Yup.string()
    .min(4, ru.confirmationCodeTooShort)
    .required(ru.requiredField(ru.confirmationCode)),
});

GetToken.buttonLabel = ru.signIn;

export default GetToken;
